import React, { useState, useEffect, useRef } from "react";
import { SmallSaleCampaignTimerWrapper } from "../../containers/SalePromotionCampaign/SaleCampaign.style";
import { minusHour } from "../../store/actions/promotionCampaignAction";
import t from "../../i18n/translate";

export const SaleCampaignTimer = ({ campaign, resetCampaign }) => {
	let end_date = campaign?.sale_promotion_campaign_product?.end_date;

	let interval = useRef(null);

	const [days, setDays] = useState("00");
	const [hours, setHours] = useState("00");
	const [minutes, setMinutes] = useState("00");
	const [seconds, setSeconds] = useState("00");

	const startTimer = () => {
		let countDownDate = new Date(minusHour(end_date, 7))?.getTime();

		interval.current = setInterval(() => {
			let second = 1000;
			let minute = second * 60;
			let hour = minute * 60;
			let day = hour * 24;

			let nowDate = new Date().getTime();
			let distance = countDownDate - nowDate;

			let days = Math.floor(distance / day)
				.toString()
				.padStart(2, "0");
			let hours = Math.floor((distance % day) / hour)
				.toString()
				.padStart(2, "0");
			let minutes = Math.floor((distance % hour) / minute)
				.toString()
				.padStart(2, "0");
			let seconds = Math.floor((distance % minute) / second)
				.toString()
				.padStart(2, "0");

			if (distance <= 0) {
				resetCampaign();
				window.location.href = localStorage.getItem("expressMode")
					? "/express"
					: "/";
				return () => {
					clearInterval(interval.current);
				};
			} else {
				setDays(days);
				setHours(hours);
				setMinutes(minutes);
				setSeconds(seconds);
			}
		}, 1000);
	};

	// componentDidMount
	useEffect(() => {
		startTimer();
		return () => {
			clearInterval(interval.current);
		};
	});

	return (
		<SmallSaleCampaignTimerWrapper>
			<div className="timer-item-wrapper">
				<span className="timer-number days">{end_date ? days : "00"}</span>
				<p className="timer-label days">{t("promotion_campaign_days_label")}</p>
			</div>
			<div className="divider">
				<span className="dot"></span>
				<span className="dot"></span>
			</div>
			<div className="timer-item-wrapper">
				<span className="timer-number hours">{end_date ? hours : "00"}</span>
				<p className="timer-label hours">{t("promotion_campaign_hours_label")}</p>
			</div>
			<div className="divider">
				<span className="dot"></span>
				<span className="dot"></span>
			</div>
			<div className="timer-item-wrapper">
				<span className="timer-number minutes">{end_date ? minutes : "00"}</span>
				<p className="timer-label minutes">{t("promotion_campaign_minutes_label")}</p>
			</div>
			<div className="divider">
				<span className="dot"></span>
				<span className="dot"></span>
			</div>
			<div className="timer-item-wrapper">
				<span className="timer-number seconds">{end_date ? seconds : "00"}</span>
				<p className="timer-label seconds">{t("promotion_campaign_seconds_label")}</p>
			</div>
		</SmallSaleCampaignTimerWrapper>
	);
};

export default SaleCampaignTimer;
